module.exports = __webpack_public_path__ + "img/logo_prolins.3c36ce63.png";